<script>
    // For the proof-stat row under the hero. The revamp blueprint flagged this
    // as the one conversion pattern worth porting out of the "modern minimal"
    // direction and into the dark editorial brand.
    //
    //   <Stat value="10,224" label="Products analyzed" />
    //   <Stat value="11" label="Skin concerns detected" caption="Not a diagnosis" />
    //
    // Only put a real number here. An invented proof stat is worse than none.

    export let value;
    export let label;
    export let caption = null;
    export let align = 'center'; // center | start
</script>

<style>
    .stat { display: flex; flex-direction: column; gap: var(--space-1); }

    .center { align-items: center; text-align: center; }
    .start  { align-items: flex-start; text-align: left; }

    .value {
        font-family: var(--font-display);
        font-size: var(--text-2xl);
        font-weight: var(--weight-regular);
        line-height: var(--leading-tight);
        color: var(--cream);
    }

    .label {
        font-size: var(--text-2xs);
        font-weight: var(--weight-medium);
        letter-spacing: var(--track-label);
        text-transform: uppercase;
        color: var(--text-muted);
    }

    .caption {
        font-size: var(--text-xs);
        color: var(--text-muted);
        opacity: 0.8;
    }
</style>

<div class="stat {align}">
    <span class="value">{value}</span>
    <span class="label">{label}</span>
    {#if caption}<span class="caption">{caption}</span>{/if}
</div>
